import React from "react";
import { Phone, MessageSquare } from "lucide-react";

export default function StickyCTA({ t }) {
  const goContact = () => {
    const el = document.getElementById("contact");
    if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
  };
  return (
    <div
      data-testid="sticky-cta"
      className="md:hidden fixed bottom-4 left-4 right-4 z-40 grid grid-cols-3 gap-3"
    >
      <a
        href="tel:+4746393022"
        data-testid="sticky-call"
        aria-label={t.sticky.call}
        className="col-span-1 flex items-center justify-center gap-2 bg-white border border-slate-300 text-[#0A0F1C]/70 font-semibold tracking-[0.18em] uppercase text-[11px] py-3 shadow-sm"
      >
        <Phone className="w-4 h-4" strokeWidth={1.8} />
      </a>
      <button
        onClick={goContact}
        data-testid="sticky-quote"
        className="col-span-2 flex items-center justify-center gap-2 bg-[#0F2C29] text-white font-bold tracking-[0.22em] uppercase text-[12px] py-3 shadow-lg"
      >
        <MessageSquare className="w-4 h-4" strokeWidth={1.8} /> {t.sticky.quote}
      </button>
    </div>
  );
}
